export default "__VITE_ASSET__CvEqztsL__"